/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateSupplierRequest } from '../models/CreateSupplierRequest';
import type { Supplier } from '../models/Supplier';
import type { UpdateSupplierRequest } from '../models/UpdateSupplierRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class SupplierService {
    /**
     * @param teamId
     * @returns Supplier OK
     * @throws ApiError
     */
    public static getApiSupplierTeam(
        teamId: number,
    ): CancelablePromise<Array<Supplier>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Supplier/team/{teamId}',
            path: {
                'teamId': teamId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns Supplier OK
     * @throws ApiError
     */
    public static postApiSupplier(
        requestBody?: CreateSupplierRequest,
    ): CancelablePromise<Supplier> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Supplier',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @param id
     * @returns Supplier OK
     * @throws ApiError
     */
    public static getApiSupplier(
        id: number,
    ): CancelablePromise<Supplier> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Supplier/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @param id
     * @param requestBody
     * @returns Supplier OK
     * @throws ApiError
     */
    public static putApiSupplier(
        id: number,
        requestBody?: UpdateSupplierRequest,
    ): CancelablePromise<Supplier> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/Supplier/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
}
